import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
export const JumboOpeningHours = (props)=>{
    const { open, readableTime, additionalInformation } = props;
    const handleScroll = (event)=>{
        event.preventDefault();
        const targetElement = document.querySelector('#openingstijden');
        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth'
            });
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "jumbotron__opening-times",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    "Vandaag ",
                    open ? `open tussen ${readableTime}` : 'gesloten'
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: additionalInformation
            }),
            /*#__PURE__*/ _jsx("a", {
                className: "link",
                href: "#openingstijden",
                onClick: handleScroll,
                children: "Bekijk alle openingstijden"
            })
        ]
    });
};
